import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivity/registration';

const translations = generateTranslations(namespace, {
  studenter: {
    nb: 'Undervisningsmeldte studenter',
    en: 'Students',
  },
  klasse: {
    nb: 'Praksisklasse',
    en: 'Practice Class',
  },
  fsKlasse: {
    nb: 'FS-klasse',
    en: 'FS-class',
  },
  velg: {
    nb: 'Velg',
    en: 'Select',
  },
  registrerAlle: {
    nb: 'Registrer alle til',
    en: 'Register all to',
  },
  registrerValgte: {
    nb: 'Registrer valgte til',
    en: 'Register selected to',
  },
  fjernAlle: {
    nb: 'Fjern alle registreringer til',
    en: 'Remove all students registered to',
  },
  fjernValgte: {
    nb: 'Fjern valgte registreringer',
    en: 'Remove selected registrations',
  },
  lagre: {
    nb: 'Lagre',
    en: 'Save',
  },
  lagret: {
    nb: 'Registrerte praksisklasser lagret',
    en: 'Registrated practice classes saved',
  },
  fjern: {
    nb: 'Fjern',
    en: 'Remove',
  },
  avmeldtStudent: {
    nb: 'Studenten har blitt avmeldt fra undervisning i FS',
    en: 'The student is no longer signed up for studies',
  },
  ikkeRegistrertStudent: {
    nb: 'Studenten har blitt undervisningsmeldt til tjenesten',
    en: 'The student has been signed up for the service',
  },
  cancel: {
    nb: 'Avbryt',
    en: 'Cancel',
  },
  confirmEdit: {
    nb: 'Bekreft endring i klasser',
    en: 'Confirm class edit',
  },
  removeStudentInfo1: {
    nb: 'Du er i ferd med å fjerne/endre plassering i en praksisklasse for én eller flere studenter.',
    en: 'You are about to alter/remove the placement in a practice class for one or more students.',
  },
  removeStudentInfo2: {
    nb: 'Ved endring i plassering vil studenten(e) miste eventuelle fordelinger i alle pågående/fremtidige aktiviteter i klassen f.o.m. i dag.',
    en: 'Changing the placement will result in the student(s) losing any distributions in all ongoing and potential future activities for this class from today onward.',
  },
  removeStudentInfo3: {
    nb: 'Dersom ønskelisten er åpen, vil alle ønskene bli slettet og studentene må sende inn ønskene sine på nytt.',
    en: 'If the wish list is open, all wishes will be deleted and the students must resubmit their wishes.',
  },
  removeStudentTitle: {
    nb: 'Bekreft fjerning av studenter fra deres praksisklasse',
    en: 'Confirm removal of students from their practice class',
  },
  selectAll: {
    nb: 'Velg alle',
    en: 'Select all',
  },
});

export default translations;
